<template>
  <b-form-select :value="value" :options="events" value-field="@id" text-field="title" :required="required"
    @change="$emit('input', $event)">
    <template #first>
      <b-form-select-option :value="null">-- Select an Event --</b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'FormSelectEvent',
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['events'])
  },
}
</script>
